// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"ee167586","301":"221568d2","369":"845dae92","446":"a1b3d0a5","488":"eb905bca","760":"915fb17b","951":"b21b3031"}[chunkId] + ".chunk.js";
};